import type { SessionPolicySeconds, SessionTimingConfig } from './types';

/**
 * Convert the /config session policy (seconds, warning fields expressed as
 * offsets before the deadline) into the absolute millisecond thresholds the
 * provider's timers compare against.
 */
export function deriveSessionTimingConfig(session: SessionPolicySeconds): SessionTimingConfig {
  return {
    inactivityTimeoutMs: session.inactivityTimeoutSeconds * 1000,
    inactivityWarningMs: Math.max(
      0,
      (session.inactivityTimeoutSeconds - session.inactivityWarningOffsetSeconds) * 1000
    ),
    maxDurationMs: session.maxDurationSeconds * 1000,
    maxDurationWarningMs: Math.max(
      0,
      (session.maxDurationSeconds - session.maxDurationWarningOffsetSeconds) * 1000
    ),
    autoRedirectMs: session.autoRedirectSeconds * 1000,
    pingIntervalMs: session.pingIntervalSeconds * 1000,
  };
}
